import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Box, Select, MenuItem, Stack } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import { useDispatch } from 'react-redux';
import { updateUserSettings } from 'app/store/features/userSettingsSlice';

function LanguageSwitcher({ loggedIn, flag }) {
  const { i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();

  const pathname = location.pathname;
  const handleLanguage = e => {
    i18n.changeLanguage(e.target.value);
    loggedIn && dispatch(updateUserSettings({key: 'lang', value: i18n.language}));
    localStorage.setItem('lang', JSON.stringify(i18n.language));
  };

  const { t } = useTranslation('translation', { keyPrefix: 'lang' });

  const currentLang = JSON.parse(localStorage.getItem('lang'));
  return (
    <Box
      sx={{
        height: '5vh',
        width: '8vw',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Select
        value={currentLang}
        onChange={handleLanguage}
        name='lang'
        size='small'
        sx={{
          color: !flag && 'white',
          '& .MuiSelect-outlined': {
            padding: '0.3em',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: !flag && ColorsV2.white,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: !flag && ColorsV2.white,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: ColorsV2.white,
          },
          '& .MuiSelect-icon': {
            color: !flag && ColorsV2.white, // change the icon color here
            fontSize: '1rem',
          },
        }}
        inputProps={{
          MenuProps: {
            fontSize: '0.6em',
            MenuListProps: {
              sx: {
                backgroundColor: !flag && ColorsV2.secondary,
                color: !flag && 'white',
                border: !flag && `2px solid ${ColorsV2.white}`,
                '& .MuiMenuItem-root.Mui-selected': {
                  backgroundColor: !flag && ColorsV2.acent,
                  borderRadius: !flag && '8px',
                },
                '& .MuiMenuItem-root:hover': {
                  backgroundColor: !flag && ColorsV2.acent,
                  borderRadius: !flag && '8px',
                },
                '& .MuiMenuItem-root.Mui-selected:hover': {
                  backgroundColor: !flag && ColorsV2.acent,
                  borderRadius: !flag && '8px',
                },
              },
            },
          },
        }}
      >
        <MenuItem
          value='en'
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            textAlign: 'center',
            fontSize: '0.7em',
            // border: '1px solid balck',
            margin: !flag && '5px',
          }}
        >
          {pathname === '/settings' || pathname === '/' ? (
            t('eng')
          ) : (
            <Stack direction='row' spacing={2} sx={{ color: 'black' }}>
              <img src='/assets/images/eng.svg' alt='' />
              <h5>Eng</h5>
            </Stack>
          )}
        </MenuItem>

        <MenuItem
          value='sv'
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            textAlign: 'center',
            fontSize: '0.7em',
            // border: '1px solid balck',
            margin: !flag && '5px',
          }}
        >
          {pathname === '/settings' || pathname === '/' ? (
            t('sw')
          ) : (
            <Stack direction='row' spacing={2} sx={{ color: 'black' }}>
              <img src='/assets/images/sw.svg' alt='' />
              <h5>SE</h5>
            </Stack>
          )}
        </MenuItem>
      </Select>
    </Box>
  );
}

export default LanguageSwitcher;
